import { auth } from "../auth/auth";
import { signOut } from "firebase/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PresentationCard from "../components/PresentationCard";
import { createDeck, getUserDecks, deleteDeck } from "../services/deckService";
import Header from "../components/Header";

export default function Dashboard() {
    const [decks, setDecks] = useState([]);
    const [loading, setLoading] = useState(true); // <--- New loading state
    const navigate = useNavigate();

    // This useEffect is generally for debugging and can be removed in production
    useEffect(() => {
        console.log("Current decks:", decks);
    }, [decks]);

    useEffect(() => {
        const fetchDecks = async () => {
            setLoading(true); // Start loading
            if (auth.currentUser) {
                try {
                    const fetchedDecks = await getUserDecks(auth.currentUser.uid);
                    setDecks(fetchedDecks);
                } catch (error) {
                    console.error("Error fetching decks:", error);
                    // Optionally handle error state, e.g., display an error message
                }
            }
            setLoading(false); // End loading
        };

        fetchDecks();

        // Optional: If you use an onAuthStateChanged listener, you might also
        // want to re-fetch or clear decks when the user changes.
        // For simplicity, we are relying on auth.currentUser in the dependency array.

    }, [auth.currentUser]);

    async function handleDelete(deckId) {
        if (!auth.currentUser) return;

        setLoading(true); // Start loading for delete operation
        try {
            await deleteDeck(deckId, auth.currentUser.uid);
            const updated = await getUserDecks(auth.currentUser.uid);
            setDecks(updated);
        } catch (error) {
            console.error("Error deleting deck:", error);
            // Optionally handle error state
        }
        setLoading(false); // End loading for delete operation
    }

    async function handleCreateNewDeck() {
        if (!auth.currentUser) return;

        setLoading(true); // Start loading for create operation
        try {
            const deck = await createDeck(auth.currentUser.uid);
            navigate(`/editor/${deck.id}`);
        } catch (error) {
            console.error("Error creating new deck:", error);
            // Optionally handle error state
        }
        // No need to set setLoading(false) here, as navigation will unmount/remount
        // or trigger a new fetch in the Editor component.
        // If you were staying on the dashboard, you would set it to false here.
    }


    return (
        <div>
            <Header />

            {loading ? (
                // Display a loading message or spinner
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100vh - 56px)" }}>
                    <p>Loading decks...</p> {/* You can replace this with a spinner component */}
                </div>
            ) : (
                // Display content once loading is complete
                <div style={{ display: "flex", padding: '1.5rem', flexWrap: 'wrap' }}>
                    {decks.map((deck) => (
                        <PresentationCard
                            key={deck.id}
                            deck={deck}
                            onClick={() => navigate(`/editor/${deck.id}`)}
                            onDelete={() => handleDelete(deck.id)}
                        />
                    ))}
                    <PresentationCard
                        key={"new-deck-card"}
                        deck={{}}
                        variant={"plus"}
                        onClick={handleCreateNewDeck} // <--- Call the new handler
                    />
                </div>
            )}
        </div>
    );
}
